import React from "react";
import ProtectedRoutes from "./protectedRoutes";
import InspectionDetails from "../pages/InspectionDetails/index";
import UserDetails from "../pages/UserDetails/index";
import DeletedUsers from "../pages/DeletedUsers/index";
import PoolDetails from "../pages/PoolDetails/index";
import { jwtDecode } from "jwt-decode";
import { getUserDetails } from "../utils/utils";

const { token } = getUserDetails();
const decoded = token ? jwtDecode(token) : {};

const privateRoutes = [
  {
    path: "/",
    element: <ProtectedRoutes element={<InspectionDetails />} />,
  },
  {
    path: "inspection-details",
    element: <ProtectedRoutes element={<InspectionDetails />} />,
  },
];

if (decoded?.role !== "Client") {
  privateRoutes.push(
    {
      path: "pool-details",
      element: <ProtectedRoutes element={<PoolDetails />} />,
    },
    {
      path: "user-details",
      element: <ProtectedRoutes element={<UserDetails />} />,
    },
    {
      path: "deleted-user",
      element: <ProtectedRoutes element={<DeletedUsers />} />,
    }
  );
}

export default privateRoutes;
